import Blank from "./Blank.vue";
import Default from "./Default.vue";
import Selection from "./Selection.vue";
export const layouts = { Blank, Default, Selection };
export type LayoutNames = keyof typeof layouts;
export type LayoutComponents<T extends LayoutNames> = (typeof layouts)[T];
